import { Button, Clickable, Col, Icon, Row, Text } from 'components';
import { useOutsideClick } from 'core';
import { Api, revenueTargetOptions, theme } from 'lib';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 447px;
  width: 264px;
  border-radius: 24px;
  position: absolute;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  top: 280px;
  padding: 0 16px;
`;

const RevenueOption = ({ option, selectedOption, setSelectedOption, amount }) => {
  const isSelected = amount === selectedOption,
    { t } = useTranslation();

  return (
    <Clickable onClick={() => setSelectedOption(amount)}>
      <Row
        pad="9px 23px"
        bg={isSelected ? theme.SECONDARY_20 : theme.GREY_10}
        wid="216px"
        hasRadius="32px"
        hasBorder={`1px solid ${isSelected ? theme.SECONDARY : 'transparent'}`}
        centerAll
      >
        <Text b1 med>
          {option}
        </Text>
      </Row>
    </Clickable>
  );
};

const RevenueSelector = ({ handleModal, revenueTarget }) => {
  const selectorRef = useRef(null),
    [selected, setSelected] = useState(revenueTarget),
    { t } = useTranslation(),
    dispatch = useDispatch();

  useOutsideClick(selectorRef, handleModal);

  async function handleSelect(opt) {
    const res = await Api.post(
      '/users/updateRevenueTarget',
      { value: selected },
      'updateRevenueTarget'
    );
    if (!res) return;

    dispatch({
      type: 'UPDATE_USER',
      payload: { revenueTarget: opt }
    });

    handleModal();
  }

  function discard() {
    setSelected(revenueTarget);

    handleModal();
  }

  return (
    <Wrapper ref={selectorRef}>
      <Col between>
        <Col noFlex>
          <Col pos="absolute" right="21px" top="21px">
            <Clickable onClick={handleModal}>
              <Icon type="close" dimensions={14} col={theme.GREY_60} />
            </Clickable>
          </Col>

          <Text h3 marg="29px 0 0">
            Edit monthly target
          </Text>

          <Col noFlex marg="24px 0 0" gap="8px">
            {revenueTargetOptions
              .filter((x) => x.amount)
              .map((x, i) => (
                <RevenueOption
                  key={i}
                  option={t(x.value)}
                  amount={x.amount}
                  selectedOption={selected}
                  setSelectedOption={setSelected}
                />
              ))}
          </Col>
        </Col>

        <Row gap="8px" wid="fit-content" marg="0 0 16px">
          <Button
            text={t('common.save')}
            wid="fit-content"
            pad="0 24px"
            onClick={() => handleSelect(selected)}
          />

          <Button
            text={t('common.discard')}
            bordered
            wid="fit-content"
            onClick={discard}
            pad="0 24px"
          />
        </Row>
      </Col>
    </Wrapper>
  );
};

export default RevenueSelector;
